<template>
  <report-layout :available-reports="$parent.availableReports" :openedReport="$parent.openedReport" close-path="/team/reports">
    <template v-slot:header>
      <div>
        <h1 class="info-headline">{{$t('Work Community Experience')}}</h1>
        <h5><span>{{ $t('The overall experience of working in a work community can be reflected in how people feel about their job and if they would recommend it to others.') }}</span></h5>
      </div>
    </template>
    <div v-if="!$parent.loading && $parent.currentEngagementReport.stats">
      <b-row align-v="center" align-h="left" class="mt-4">
        <b-col cols="12" sm="12" md="10" lg="10" offset-md="1" offset-lg="1">
          <h2>Satisfaction</h2>
          <p>When asking how happy members of this work community are working in this work community, this is how people feel currently.</p>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-4">
        <b-col cols="12" sm="12" md="5" order-md="2">
          <b-row>
            <b-col>
              <div class="overall-score">
                <span class="--value">{{$parent.satisfactionToIndex($parent.currentSatisfactionReport.stats.avg)}}</span>
                <span class="--scale">/ 100</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="animated-bar has-negative">
                <!-- {{($parent.satisfactionToIndex($parent.currentSatisfactionReport.stats.avg)/100)}} -->
                <div v-if="$parent.currentSatisfactionReport.stats.avg < 0" class="meter negative activated" style="background: rgba(214,69,69,1);" :style="{'width': $parent.formatPercent(($parent.satisfactionToIndex($parent.currentSatisfactionReport.stats.avg)/-200))}"></div>
                <div v-else class="meter activated" style="background: rgba(87,203,60,1); margin-left: 50%;" :style="{'width': $parent.formatPercent(($parent.satisfactionToIndex($parent.currentSatisfactionReport.stats.avg)/200))}"></div>
                <!-- <div class="meter" :class="{'activated': true}" :style="{'background': `linear-gradient(90deg, rgba(87,203,60,1) 0%, rgba(215,193,14,1) ${$parent.formatPercent(0.5/($parent.satisfactionToIndex($parent.currentSatisfactionReport.stats.avg)/100))}, rgba(214,69,69,1) ${$parent.formatPercent(1/($parent.satisfactionToIndex($parent.currentSatisfactionReport.stats.avg)/100))})`, 'width': $parent.formatPercent(($parent.satisfactionToIndex($parent.currentSatisfactionReport.stats.avg)/100))}"></div> -->
                <!-- <div class="meter" :class="{'activated': $parent.currentSatisfactionReport.stats !== undefined}" :style="{'background-color': , 'width': $parent.satisfactionToIndex($parent.currentSatisfactionReport.stats.avg)}"></div> -->
              </div>
              <p class="tidbit">{{$t('common:updated')}} {{$parent.currentSatisfactionReport.stats.updatedAt | moment('from')}}.</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="5" order-md="1">
          <h3 class="feedback-title">
            <span>On average, how happy are people to work in this work community?</span>
          </h3>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-4">
        <b-col cols="12" sm="12" md="5" order-md="2">
          <barchart :items="$parent.satisfactionItems"/>
        </b-col>
        <b-col cols="12" md="5" order-md="1">
          <h3 class="feedback-title mt-3">
            <span>
              How does satisfaction differ between people?
            </span>
          </h3>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="left" class="mt-5">
        <b-col cols="12" sm="12" md="10" lg="10" offset-md="1" offset-lg="1">
          <h2 class="mb-4 mt-4">Advocacy</h2>
          <p class="tidbit">{{$t('common:updated')}} {{$parent.currentRecommendationReport.stats.updatedAt | moment('from')}}.</p>
          <p>The question whether people feel they could recommend this work community to others or not can reveal another dimension of job satisfaction and loyality.</p>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-5">
        <b-col cols="12" sm="12" md="5" order-md="2">
          <b-row>
            <b-col>
              <div class="overall-score">
                <span class="--value">{{$parent.satisfactionToIndex($parent.currentRecommendationReport.stats.avg)}}</span>
                <span class="--scale"> (index between -100 &mdash; 100)</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="animated-bar has-negative">
                <!-- {{($parent.satisfactionToIndex($parent.currentRecommendationReport.stats.avg)/100)}} -->
                <div v-if="$parent.currentRecommendationReport.stats.avg < 0" class="meter negative activated" style="background: rgba(214,69,69,1);" :style="{'width': $parent.formatPercent(($parent.satisfactionToIndex($parent.currentRecommendationReport.stats.avg)/-200))}"></div>
                <div v-else class="meter activated" style="background: rgba(87,203,60,1); margin-left: 50%;" :style="{'width': $parent.formatPercent(($parent.satisfactionToIndex($parent.currentRecommendationReport.stats.avg)/200))}"></div>
                <!-- <div class="meter" :class="{'activated': true}" :style="{'background': `linear-gradient(90deg, rgba(87,203,60,1) 0%, rgba(215,193,14,1) ${$parent.formatPercent(0.5/($parent.satisfactionToIndex($parent.currentRecommendationReport.stats.avg)/100))}, rgba(214,69,69,1) ${$parent.formatPercent(1/($parent.satisfactionToIndex($parent.currentRecommendationReport.stats.avg)/100))})`, 'width': $parent.formatPercent(($parent.satisfactionToIndex($parent.currentRecommendationReport.stats.avg)/100))}"></div> -->
                <!-- <div class="meter" :class="{'activated': $parent.currentRecommendationReport.stats !== undefined}" :style="{'background-color': , 'width': $parent.satisfactionToIndex($parent.currentRecommendationReport.stats.avg)}"></div> -->
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="5" order-md="1">
          <h3 class="feedback-title">
            <span>The advocacy index tells how strongly on average people feel that they could recommend this work community.</span>
          </h3>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-5">
        <b-col cols="12" sm="12" md="5" order-md="2">
          <b-row>
            <b-col>
              <div class="pie">
                <doughnut-chart :values="recommendationDonoughtData"/>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="5" order-md="1">
          <h3 class="feedback-title">
            <span>The majority of members of this work community feels that they could recommend it to others.</span>
          </h3>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-5">
        <b-col cols="12" sm="12" md="5" order-md="2">
          <barchart :items="$parent.recommendationItems"/>
        </b-col>
        <b-col cols="12" md="5" order-md="1">
          <h3 class="feedback-title mt-3">
            <span>
              Not all are certain that they could recommend this work community. There are also people who would not recommend it.
            </span>
          </h3>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="left" class="mt-5">
        <b-col cols="12" sm="12" md="10" lg="10" offset-md="1" offset-lg="1">
          <p style="white-space: pre-line;">
            It might be a good idea to talk about the reasons behind the different views on recommending this work community:
          </p>
          <ul>
            <li>What would improve how people's experience to the point that they would feel comfortable recommending it to others?</li>
            <li>Why do some people feel that they could definitely recommend this work community? Which aspects of it are especially appealing? How could those aspects be strenghened even more?</li>
            <li>If people have changed their mind about this, what are the reasons behind it? What could change their mind in the future?</li>
          </ul>
        </b-col>
      </b-row>

    </div>
    <div v-else class="loadingScreen"></div>
  </report-layout>
</template>
<script>
import BarChart from '../../common/barchart/BarChart'
import ReportLayout from '../../layouts/ReportLayout'
import DoughnutChart from '../../common/doughnut/Doughnut'

export default {
  components: {
    barchart: BarChart,
    ReportLayout,
    DoughnutChart
  },
  mounted: function () {
    this.$parent.openedReport = 'satisfaction'
  },
  computed: {
    recommendationDonoughtData () {
      if (!this.$parent.currentRecommendationReport.stats) {
        return null
      }
      return [
        {
          value: this.$parent.currentRecommendationReport.stats.classDefinitelyYes + this.$parent.currentRecommendationReport.stats.classProbablyYes,
          color: '#62c829',
          label: 'Definitely or probably yes'
        },
        {
          value: this.$parent.currentRecommendationReport.stats.classDefinitelyNot + this.$parent.currentRecommendationReport.stats.classProbablyNot + this.$parent.currentRecommendationReport.stats.classNotSure,
          color: '#cccccc',
          label: 'Not sure, probably not, or definitely not'
        }
      ]
    }
  }
}
</script>
